import { Button, Form } from "antd";
import Upload from "antd/es/upload";
import { UploadOutlined } from "@ant-design/icons";
import { useUploadFile } from "../../../../../../../lib/hooks/useUploadFile";
import { useUploadFileRule } from "../../../../../../../lib/hooks/useUploadFileRule";

type UploadFileFormItemProps = {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  uploadType: 1 | 5;
  label?: string;
  title?: string;
};

export const UploadFileFormItem = ({
  setIsLoading,
  uploadType,
  label,
  title,
}: UploadFileFormItemProps) => {
  const { upload } = useUploadFile(uploadType, setIsLoading);

  const { rule } = useUploadFileRule();

  return (
    <Form.Item
      name="file"
      className="mb-6 w-100"
      valuePropName="fileList"
      getValueFromEvent={(e) => e.fileList}
      rules={rule}
      label={label}
    >
      <Upload
        listType="picture"
        customRequest={upload}
        maxCount={1}
        previewFile={async () => ""}
      >
        <Button icon={<UploadOutlined />} shape="round">
          {title || "Upload file"}
        </Button>
      </Upload>
    </Form.Item>
  );
};
